import { UserPermissions } from '../constants/constants'
import { useAppSelector } from '../redux/hook'
import { hasPermissionCheck } from '../utils/PermissionsUtils'

export const usePermissions = (): {
    hasPermission: (required: UserPermissions | UserPermissions[]) => boolean
} => {
    const permissions = useAppSelector((state) => state.org.permissions)

    const hasPermission = (required: UserPermissions | UserPermissions[]) => {
        return hasPermissionCheck(permissions, required)
    }

    return { hasPermission }
}
